import React from 'react';

type Variant = 'display' | 'title' | 'heading' | 'body-lg' | 'body' | 'label' | 'caption';
type Color = 'primary' | 'secondary' | 'muted' | 'inverse';

const variantClass: Record<Variant, string> = {
  display: 'text-display font-display',
  title: 'text-title font-sans font-semibold tracking-tight',
  heading: 'text-heading font-sans font-semibold',
  'body-lg': 'text-body-lg font-sans',
  body: 'text-body font-sans',
  label: 'text-label font-sans font-medium tracking-wide',
  caption: 'text-caption font-sans',
};

const colorClass: Record<Color, string> = {
  primary: 'text-text-primary',
  secondary: 'text-text-secondary',
  muted: 'text-text-muted',
  inverse: 'text-text-inverse',
};

type Props = React.HTMLAttributes<HTMLElement> & {
  variant?: Variant;
  color?: Color;
  tabular?: boolean;
  as?: keyof React.JSX.IntrinsicElements;
};

export const Text: React.FC<Props> = ({
  variant = 'body',
  color = 'primary',
  tabular = false,
  as: As = 'p',
  className = '',
  children,
  ...rest
}) => {
  const Component = As as React.ElementType;
  return (
    <Component
      className={[variantClass[variant], colorClass[color], tabular ? 'tabular' : '', className]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </Component>
  );
};
